var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function ($, global, google) {
    "use strict";
    var geocoder = null;
    var geocoderLoader = null;
    // google visualisation loader
    $.extend(MDB.Charts, {
        /**
         * Loads the requested packages and executes the callback functions
         */
        getGeocoder: function (callback) {
            if(geocoderLoader) {
                geocoderLoader.done(callback);
                return geocoderLoader;
            }

            var d = new $.Deferred();            
            geocoderLoader = d;
            if(geocoder) {
                if(callback) {
                    d.done(callback);
                }
                d.resolve(geocoder); 
            } else {
                var methodName = "_googleGeocoderCallback" + parseInt(Math.random() * 100000, 10);
                global[methodName] = function(){ 
                    if(!geocoder) {
                        geocoder =  new google.maps.Geocoder();
                    }
                    d.resolve(geocoder); 
                };
                $.ajax({
                    url: "https://maps.googleapis.com/maps/api/js?v=3&callback="+methodName+"&sensor=false",
                    dataType: "script"
                });
            }
            return d.promise();
        },
        getCoordinatesForAddress:function(address, callback) {
            var d = new $.Deferred();     
            if(callback) {
                d.done(callback);
            }       
            
            MDB.Charts.getGeocoder(function(geocoder) {
                geocoder.geocode( { 'address': address}, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        d.resolve(results[0].geometry.location);
                        //callback(results[0].geometry.location);
                    } else {
                        d.reject();
                    }
                });
            });
            return d.promise();
        }
    });


    $.extend(MDB.Charts, {
         
    });


})(jQuery, window, window.google);




